import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, tap, map } from 'rxjs/operators';
import { throwError, Observable, Subject, BehaviorSubject } from 'rxjs';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class ReservationsService {
  url = environment.url;

  constructor(public http: HttpClient) { }


  getAllUnassignedGreets() {
    let date = moment().startOf('day').format("MM/DD/YYYY HH:mm");
    let data = { "date": date }
    return this.http.post(`${this.url}` + '/reservations/getAllUnassignedGreets', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getAllUnassignedGreets'))),
    );
  }

  getAllAssignedGreets() {
    let date = moment().startOf('day').format("MM/DD/YYYY HH:mm");
    let data = { "date": date }
    return this.http.post(`${this.url}` + '/reservations/getAllAssignedRequests', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getAllAssignedRequests'))),
    );
  }

  getAllCancelledGreets() {
    let date = moment().startOf('day').format("MM/DD/YYYY HH:mm");
    let data = { "date": date }
    return this.http.post(`${this.url}` + '/reservations/getAllCancelledRequests', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getAllAssignedRequests'))),
    );
  }

  requestFilter(reqBody) {
    return this.http.post(`${this.url}` + '/reservations/requestfilter', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation based on filters'))),
    );
  }

  requestFilterForAssigned(reqBody) {
    return this.http.post(`${this.url}` + '/reservations/requestfilterForAssigned', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation based on filters'))),
    );
  }

  getAllReservationStatus() {
    return this.http.get(`${this.url}` + '/resStatus/all').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting all reservation status'))),
    );
  }

  getReservationDetailsByReservationid(reservationid) {
    return this.http.get(`${this.url}` + '/paxFliDetails/getDetails/' + reservationid).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation details'))),
    );
  }

  //getGreetServicesByResId
  getGreetServicesByResId(reservationid) {
    return this.http.get(`${this.url}` + '/paxFliDetails/getGreetServicesByResId/' + reservationid).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation details'))),
    );
  }

  //insertReservationAssignmentRecord
  insertReservationAssignmentRecord(reservationid) {
    return this.http.get(`${this.url}` + '/reservations/insertReservationAssignmentRecord/' + reservationid).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting reservation details'))),
    );
  }

  getAgentsForReservation(reservationid) {
    return this.http.get(`${this.url}` + '/paxFliDetails/agentsForReservation/' + reservationid).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgentsForReservation'))),
    );
  }

  getUnassignedReservationsBystationCodes(reqBody) {
    return this.http.post(`${this.url}` + '/reservations/getUnassignedReservationsBystationCodes', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getUnassignedReservationsBystationCodes'))),
    );
  }

  getAssignedReservationsBystationCodes(reqBody) {
    return this.http.post(`${this.url}` + '/reservations/getassignedReservationsBystationCodes', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getUnassignedReservationsBystationCodes'))),
    );
  }

  getCancelledReservationsBystationCodes(reqBody) {
    return this.http.post(`${this.url}` + '/reservations/getCancelledReservationsBystationCodes', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getUnassignedReservationsBystationCodes'))),
    );
  }


  getCompletedResServiceNotes(resId, userId) {
    let reqBody = {
      "resId": resId,
      "userId": userId
    }
    return this.http.post(`${this.url}` + '/reservations/completedDetails', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed reservation service notes'))),
    );
  }

  completeReservation(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/completeGreet', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed greet'))),
    );
  }
  inProgreesToCompleteByAdmin(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/inProgreesToCompleteByAdmin', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed greet'))),
    );
  }

  incompleteWithCharges(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/incompleteWithCharges', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed greet'))),
    );
  }

  incompleteWithOutCharges(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/incompleteWithOutCharges', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed greet'))),
    );
  }

  //getBeforeDayGreetsInfo
  getBeforeDayGreetsInfo() {
    return this.http.get(`${this.url}` + '/assignments/getBeforeDayGreetsInfo').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgentsForReservation'))),
    );
  }



  //getConciergeReport
  getConciergeReport(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/getConciergeReport', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getConciergeReport'))),
    );
  }
  //getConciergeReportFor Manager
  getConciergeReportForStationManager(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/getConciergeReportByStationManager', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getConciergeReport'))),
    );
  }

    //getConciergeReportFor Filter
    getConciergeReportByFilter(requestBody) {
      return this.http.post(`${this.url}` + '/assignments/getConciergeReportByFilter', requestBody).pipe(tap(res => res),
        catchError(err => throwError(new Error('Issue in getConciergeReport'))),
      );
    }

  cancelGreet(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/swapAssignment', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get cancel greet'))),
    );
  }


  assignGreetForOverLapedSlot(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/acceptRequestOfOverlapped', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get acceptRequestOfOverlapped greet'))),
    );
  }

  assignOverLapeGreetForSecondary(requestBody) {
    return this.http.post(`${this.url}` + '/employeeSecondary/assignOverlapSecondaryAgentFromWEB', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get acceptRequestOfOverlapped greet'))),
    );
  }

  downloadCompletedReservationsExcel(requestBody): Observable<any> {
    return this.http.post(`${this.url}` + '/excel/downloadReport', requestBody, {
      responseType: "blob",
      headers: new HttpHeaders().append("Content-Type", "application/json")
    }).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in downloading excel for completed reservations'))),
    );
  }

  getAgentsGreetRequests() {
    return this.http.get(`${this.url}` + '/agentRequestGreet/getAllAgentGreetRequests').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgentsForReservation'))),
    );
  }

  //getGreetRequestList
  getGreetRequestList() {
    return this.http.get(`${this.url}` + '/agentRequestGreet/getGreetRequestList').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgentsForReservation'))),
    );
  }

  getAgentsGreetRequestsOfStationManager(requestBody) {
    return this.http.post(`${this.url}` + '/agentRequestGreet/getAllAgentGreetRequestsByStation', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgentsForReservation Manager'))),
    );
  }

  getAgentsGreetResponse() {
    return this.http.get(`${this.url}` + '/agentRequestGreet/getAllAgentsResponseGreets').pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgentsForReservation'))),
    );
  }

  getAgentsGreetResponsesOfStationManager(requestBody) {
    return this.http.post(`${this.url}` + '/agentRequestGreet/getAllAgentsResponseGreetsByStaion', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgentsForReservation Manager'))),
    );
  }

  getAgentDailyCap(requestBody) {
    return this.http.post(`${this.url}` + '/agentRequestGreet/getDailyGreetsAcceptedByUser', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get cancel greet'))),
    );
  }
  getAgentWeeklyCap(requestBody) {
    return this.http.post(`${this.url}` + '/agentRequestGreet/getWeeklyGreetsAcceptedByUser', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get cancel greet'))),
    );
  }
  approveAgentGreetRequest(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/adminApproveGreetRequest', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed greet'))),
    );
  }

  updateGreetRequest(requestBody) {
    return this.http.post(`${this.url}` + '/agentRequestGreet/updateGreetRequest', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get cancel greet'))),
    );
  }

  getGreeProgressInfoByRESID(reservationid) {
    let reqBody = {
      "resId": reservationid
    }
    return this.http.post(`${this.url}` + '/reservations/getGreetProgressInfo', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed reservation service notes'))),
    );
  }

  getSubConciergeGreeProgressInfoByRESID(reservationid) {
    let reqBody = {
      "resId": reservationid
    }
    return this.http.post(`${this.url}` + '/reservations/getSubConciergeGreetProgressInfo', reqBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed reservation service notes'))),
    );
  }

  updateGreeProgressInfoByRESID(data) {
    return this.http.post(`${this.url}` + '/reservations/updateGreetProgressInfo', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed reservation service notes'))),
    );
  }

  //updateSubConciergeGreetProgressInfo
  updateSubGreeProgressInfoByRESID(data) {
    return this.http.post(`${this.url}` + '/reservations/updateSubConciergeGreetProgressInfo', data).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed reservation service notes'))),
    );
  }

 //getGreetAgentsDetails
  getGreetAgentsDetails(resId) {
    return this.http.get(`${this.url}` + '/reservations/getGreetAgentsDetails/' + resId ).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in get completed reservation service notes'))),
    );
  }

    //updateSubConciergeGreetProgressInfo
    updateSubConciergeGreetFromWEB(data) {
      return this.http.post(`${this.url}` + '/employeeSecondary/updateSubConciergeGreetFromWEB', data).pipe(tap(res => res),
        catchError(err => throwError(new Error('Issue in get completed reservation service notes'))),
      );
    }



  notificationCount:number=0;

  // setTotalItems(value: number) {
  //   this.notificationCount.next(value);
  // }

  // getLatestNotificationCount(){
  //   return this.getAgentsGreetRequests().subscribe(res=>this.setTotalItems(res['result'].length));
  // }

  // getLatestNotificationsc(){
  //   return this.getAgentsGreetRequests().subscribe(res=>res['result'].length);
  // }

  agentsWithCapsForAssign(reservationid) {
    return this.http.get(`${this.url}` + '/paxFliDetails/agentsWithCapsForAssign/' + reservationid).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in getting getAgentsForReservation'))),
    );
  }

  reInstateReservation(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/reInStateReservation', requestBody).pipe(tap(res => res),
      catchError(err => throwError(new Error('Issue in reInState Reservation'))),
    );
  }
  monthlyInvoiceReport(requestBody) {
    return this.http.post(`${this.url}` + '/assignments/monthly-invoice-report', requestBody).pipe(tap(res => res),
        catchError(err => throwError(new Error('Issue in reInState Reservation'))),
    );
  }
}
